var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isPageLoading
    ? _c("div", [
        _vm.hasAdminAccess && (_vm.user != null || _vm.currentuser != null)
          ? _c(
              "div",
              [
                _c(
                  "v-card",
                  [
                    _c(
                      "v-card-title",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.isLoggedInUserActive,
                            expression: "!isLoggedInUserActive"
                          }
                        ]
                      },
                      [
                        _c("label", { staticStyle: { color: "red" } }, [
                          _vm._v(_vm._s(_vm.$t("msguserisnotactive")))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("v-data-table", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isLoggedInUserActive,
                          expression: "isLoggedInUserActive"
                        }
                      ],
                      attrs: {
                        headers: _vm.headers,
                        items: _vm.feedbacks,
                        search: _vm.search,
                        "footer-props": {
                          itemsPerPageOptions: _vm.tableItemsPerPage,
                          itemsPerPageText: _vm.rowsperpage
                        },
                        options: _vm.options
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "top",
                            fn: function() {
                              return [
                                _c(
                                  "v-toolbar",
                                  { attrs: { flat: "", dense: "" } },
                                  [
                                    _c("h3", [
                                      _vm._v(_vm._s(_vm.$t("feedback")))
                                    ]),
                                    _vm._v(" "),
                                    _c("v-divider", {
                                      staticClass: "mx-4",
                                      attrs: { inset: "", vertical: "" }
                                    }),
                                    _vm._v(" "),
                                    _c("v-text-field", {
                                      attrs: {
                                        "append-icon": "mdi-magnify",
                                        label: _vm.$t("searchall"),
                                        "single-line": "",
                                        "hide-details": ""
                                      },
                                      model: {
                                        value: _vm.search,
                                        callback: function($$v) {
                                          _vm.search = $$v
                                        },
                                        expression: "search"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "no-data",
                            fn: function() {
                              return [
                                _c(
                                  "v-alert",
                                  {
                                    attrs: {
                                      border: "right",
                                      "colored-border": "",
                                      type: "error",
                                      elevation: "2"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(_vm.$t("norecordsfound")) +
                                        "\n                    "
                                    )
                                  ]
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        2222254136
                      )
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _vm.user != null || _vm.currentuser != null
          ? _c(
              "div",
              [
                _c(
                  "v-alert",
                  {
                    attrs: {
                      outlined: "",
                      type: "warning",
                      prominent: "",
                      border: "left"
                    }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("accessdenied")) +
                        "\n        "
                    )
                  ]
                )
              ],
              1
            )
          : _vm._e()
      ])
    : _c(
        "div",
        [
          _c("v-progress-linear", {
            attrs: {
              indeterminate: "",
              color: "teal",
              rounded: "",
              height: "8"
            }
          })
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e1a7d96", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e1a7d96","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Feedback.vue
// module id = null
// module chunks = 